import { useContext, useEffect, useState } from "react"
import NewsCards from "../Component/home/news-cards";
import CourtNews from "../Component/home/court-news";
import Pictures from "../Component/home/pictures";
import { Context } from "../Store/context";
import MapFooter from "../Component/map/footer-map";
import NewsSlider from "../Component/slider/news-slider";
import Layout from "../Component/layout/main-layout";
import layoutBgImg from '../Images/layout/year.svg'
import layoutBgImg2 from '../Images/layout/mobileYear.svg'
import SitesSlider from "../Component/slider/useful-site";
import OnlineService from "../Component/home/online-service";
import { useTranslation } from "react-i18next";
import { Get } from "../api/services/api_helpers";
import ComplaintBoard from "../Component/home/complaint-board";

const Home = () => {
  const { t } = useTranslation()
  const [globalNews, setGlobalNews] = useState([]);
  const [localNews, setLocalNews] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const { showError } = useContext(Context);

  useEffect(() => {
    setIsLoading(true)
    const getNews = async () => {
      try {
        const globalData = await Get(`news/?category=global`);
        const localData = await Get(`news/?category=local`);
        setGlobalNews(globalData.results);
        setLocalNews(localData.results);
        setIsLoading(false)
      } catch (error) {
        showError(error.message);
        setIsLoading(false)
      }
    }
    getNews()
  }, [showError])

  const [isLgScreen, setIsLgScreen] = useState(window.innerWidth >= 620);
  useEffect(() => {
    const handleResize = () => {
      setIsLgScreen(window.innerWidth >= 620);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const sliceForSliderNews = globalNews.slice(0, 6)
  const sliceForCardsNews = globalNews.slice(0, 4)
  const sliceForLocalNews = localNews.slice(0, 4)

  const name =
    <div className="px-4 text-sm">
      <p className="font-bold text:md md:text-lg xxl:text-2xl xxxl:text-3xl">
        {t('layoutHome')}
      </p><br />
      <p className="font-regular text-sm md:text-lg xxl:text-xl xxxl:text-2xl">
        -Döwletimiziň adam hukuklaryny we azatlyklaryny goramak
        babatdaky ynsanperwer syýasatyny mundan  beýläk hem üpjün ederis.
      </p>
    </div>

  return (
    <>
      <Layout
        layoutBgImg={isLgScreen ? layoutBgImg : layoutBgImg2}
        title={isLgScreen ? name : null}
        page2="home"
      />
      <NewsSlider
        news={sliceForSliderNews}
        isLoading={isLoading}
      />
      <NewsCards
        news={sliceForCardsNews}
        isLoading={isLoading}
      />
      <OnlineService />
      <ComplaintBoard/>
    
      <CourtNews
        news={sliceForLocalNews}
        isLoading={isLoading}
      />
      <Pictures />
      <MapFooter />
      <div className="relative h-[200px]  xl:h-[300px] flex 
                      bg-secondary border-t border-t-white
                      dark:bg-dark-box items-center"
      >
        <SitesSlider />
      </div>
    </>
  );
};

export default Home;
